export const responseBlobEncryption = {
  data: {
    attributes: {
      connectionString: 'AQICAHjIV9pasxFCwcl96XQ9T7SI448IVp1d2JwsMZkDhJARcwE2Fk7iCoojGjvA2IeTsyp+AAABJDCCASAGCSqGSIb3DQEHBqCCAREwggENAgEAMIIBBgYJKoZIhvcNAQcBMB4GCWCGSAFlAwQBLjARBAxigro4oQ0OZ7zoT6sCARCAgdh+cL0yenCu1i5wZMqegFG3b+DvEHc387BUeykppYxzDSddtD2DMo8qknAJUIcPQ4moh4Lcs3gtB33d8Dz5XyilVpfvIRCU6YotG0AgjI2GzNrY628oSBQpXVjJMOvrGrvNPjtawZN/F2oiAsVFqGQVu1C1LIZEP/vtOsBtaTJCtRLZun6N6dNcmIiOBug8dq/I9Sw1UvCMEf1bkM0nOea2gEgDD7jWtT2VaqNA4WyPLFz/8b2Nog0j2Zl82UTGUviaF7fAOFvRNVJnek+uQlBteWdgsrzmIpA='
    }
  }
};